export const types = {
  "VIDEO": "video",
  "IMAGE": "img",
  "TEXT": "text"
};

export const dic = {
  [types.IMAGE]: "תמונה",
  [types.VIDEO]: "סרטון",
  [types.TEXT]: "טקסט"

};

export default {
  types,
  toString(type) {
    return dic[type] || "";
  },
  getAsOption() {
    return Object.values(types).map(type => {
      return { text: dic[type], value: type };
    });
  }

};
